<template>
  <v-card flat>
    <template v-slot:text>
      <v-text-field
        v-model="search"
        label="Search project title..."
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        hide-details
        single-line
      ></v-text-field>
    </template>
    <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
      location="top"
    >
      {{ snackText }}
    </v-snackbar>
    <v-data-table
      color="#b2d7ef"
      rounded="compact"
      divided
      striped
      hover
      class="elevation-1"
      fixed-header
      :search="search"
      :headers="headers"
      :items="projectTitles"
      :items-per-page="itemsPerPage"
      v-model:page="page"
      :sort-by="[
        { key: 'createdAt', order: 'desc' },
        { key: 'title', order: 'asc' },
      ]"
    >
      <template v-slot:top>
        <v-dialog
          v-model="dialog"
          persistent
          fullscreen
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ props }">
            <v-row>
              <v-col
                cols="6"
                md="6"
                lg="6"
                xl="6"
                class="d-flex align-center mb-4"
              >
                <v-btn
                  v-show="!visible"
                  class="mb-2 ml-4"
                  color="primary"
                  v-bind="props"
                  prepend-icon="mdi-plus"
                  variant="flat"
                >
                  <div class="text-none font-weight-regular">Add</div>
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                md="6"
                lg="6"
                xl="6"
                class="text-right d-flex mb-6 flex-row-reverse"
              >
                <v-sheet class="ma-2 pa-2 text-center">
                  <v-select
                    v-model="itemsPerPage"
                    :items="[10, 25, 50, 100, 1000]"
                    hide-details
                    density="compact"
                    variant="outlined"
                    @update:model-value="itemsPerPage = parseInt($event, 10)"
                    style="width: 100px"
                  ></v-select>
                </v-sheet>
                <v-sheet class="my-6 text-subtitle-2">Items</v-sheet>
              </v-col>
            </v-row>
          </template>
          <v-card>
            <v-toolbar>
              <v-toolbar-title prepend-icon="mdi-form-textbox">{{
                formTitle
              }}</v-toolbar-title>

              <v-btn icon="mdi-close" @click="dialog = false"></v-btn>
            </v-toolbar>
            <v-divider class="mb-0"></v-divider>
            <v-divider class="mb-0"></v-divider>
            <v-form ref="form" enctype="multipart/form-data" lazy-validation>
              <v-card-text>
                <v-alert
                  border="end"
                  border-color="warning"
                  elevation="2"
                  color="error"
                  v-show="!visibleMsg"
                >
                  {{ msgError }}
                </v-alert>
                <v-row class="mt-1">
                  <v-col cols="12">
                    <!-- Image Upload Section -->
                    <v-row class="mt-3">
                      <v-col cols="12" sm="4" class="d-flex justify-center">
                        <v-card class="image-card hover-effect">
                          <v-img
                            :src="previewImage || defaultImage"
                            class="image-upload"
                            height="200"
                            cover
                            @click="triggerFileInput(1)"
                          >
                            <div class="image-overlay">
                              <v-icon size="30" color="white"
                                >mdi-camera</v-icon
                              >
                              <span>Upload</span>
                            </div>
                          </v-img>
                        </v-card>
                        <v-file-input
                          ref="fileInput1"
                          accept="image/*"
                          style="display: none"
                          @change="uploadImage($event, 1)"
                        ></v-file-input>
                      </v-col>

                      <v-col cols="12" sm="4" class="d-flex justify-center">
                        <v-card class="image-card hover-effect">
                          <v-img
                            :src="previewImage1 || defaultImage"
                            class="image-upload"
                            height="200"
                            cover
                            @click="triggerFileInput(2)"
                          >
                            <div class="image-overlay">
                              <v-icon size="30" color="white"
                                >mdi-camera</v-icon
                              >
                              <span>Upload</span>
                            </div>
                          </v-img>
                        </v-card>
                        <v-file-input
                          ref="fileInput2"
                          accept="image/*"
                          style="display: none"
                          @change="uploadImage($event, 2)"
                        ></v-file-input>
                      </v-col>

                      <v-col cols="12" sm="4" class="d-flex justify-center">
                        <v-card class="image-card hover-effect">
                          <v-img
                            :src="previewImage2 || defaultImage"
                            class="image-upload"
                            height="200"
                            cover
                            @click="triggerFileInput(3)"
                          >
                            <div class="image-overlay">
                              <v-icon size="30" color="white"
                                >mdi-camera</v-icon
                              >
                              <span>Upload</span>
                            </div>
                          </v-img>
                        </v-card>
                        <v-file-input
                          ref="fileInput3"
                          accept="image/*"
                          style="display: none"
                          @change="uploadImage($event, 3)"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <input type="hidden" v-model="hiddenId" />
                        <v-text-field
                          v-model.trim="title"
                          :rules="[() => !!title || 'This field is required']"
                          label="Title"
                          placeholder="Title"
                          variant="outlined"
                          prepend-inner-icon="mdi-subtitles-outline"
                          required
                          autocomplete="off"
                          density="compact"
                          persistent-placeholder
                          clearable
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                        <v-label class="font-weight-thin x-small"
                          >Description</v-label
                        >
                        <QuillEditor
                          toolbar="essential"
                          contentType="html"
                          style="height: 150px"
                          v-model:content="description"
                          theme="snow"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                        <v-label class="font-weight-thin x-small"
                          >Description One</v-label
                        >
                        <QuillEditor
                          toolbar="essential"
                          contentType="html"
                          style="height: 150px"
                          v-model:content="description_one"
                          theme="snow"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                        <v-label class="font-weight-thin x-small"
                          >Description Two</v-label
                        >
                        <QuillEditor
                          toolbar="essential"
                          contentType="html"
                          style="height: 150px"
                          v-model:content="description_two"
                          theme="snow"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                        <v-label class="font-weight-thin x-small"
                          >Description Three</v-label
                        >
                        <QuillEditor
                          toolbar="essential"
                          contentType="html"
                          style="height: 150px"
                          v-model:content="description_three"
                          theme="snow"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                        <v-label class="font-weight-thin x-small"
                          >Description Four</v-label
                        >
                        <QuillEditor
                          toolbar="essential"
                          contentType="html"
                          style="height: 150px"
                          v-model:content="description_four"
                          theme="snow"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                        <v-label class="font-weight-thin x-small"
                          >Description Five</v-label
                        >
                        <QuillEditor
                          toolbar="essential"
                          contentType="html"
                          style="height: 150px"
                          v-model:content="description_five"
                          theme="snow"
                        />
                      </v-col>
                      <v-col cols="12">
                        <v-label class="font-weight-thin x-small"
                          >Description Six</v-label
                        >
                        <QuillEditor
                          toolbar="essential"
                          contentType="html"
                          style="height: 150px"
                          v-model:content="description_six"
                          theme="snow"
                        />
                      </v-col>

                      <input type="hidden" v-model="hdimage" />
                      <input type="hidden" v-model="hdimage1" />
                      <input type="hidden" v-model="hdimage2" />
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider class="mt-1"></v-divider>
            </v-form>

            <v-card-actions class="my-2 d-flex justify-end">
              <v-spacer></v-spacer>
              <v-btn
                class="text-none"
                rounded="xl"
                text="Cancel"
                @click="close"
                variant="flat"
                color="error"
              ></v-btn>

              <v-btn
                class="text-none"
                color="primary"
                rounded="xl"
                :text="buttonTitle"
                variant="flat"
                @click="save"
                :disabled="isSubmitting"
              ></v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <input type="hidden" v-model="hiddenId" />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue-darken-1" variant="text" @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <!-- detect when error  -->
      <template v-slot:no-data>
        <v-alert
          v-if="items.length > 0"
          :value="true"
          color="error"
          icon="warning"
          class="text-left"
        >
          No data found.
        </v-alert>
      </template>
      <!-- end detect when error  -->
      <!-- Custom column table -->
      <template v-slot:[`item.image`]="{ item }">
        <div v-if="item.image" class="text-center">
          <v-avatar size="80" class="my-1">
            <v-img alt="Avatar" :src="path + item.image" cover></v-img>
          </v-avatar>
        </div>
        <div v-else class="text-center">
          <v-avatar size="80" class="my-1">
            <v-img
              alt="Avatar"
              :src="defaultImage"
              cover
            >
              <template v-slot:placeholder>
                <v-row align="center" class="fill-height ma-0" justify="center">
                  <v-progress-circular
                    color="grey-lighten-5"
                    indeterminate
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </div>
      </template>
      <template v-slot:[`item.image_one`]="{ item }">
        <div v-if="item.image_one" class="text-center">
          <v-avatar size="80" class="my-1">
            <v-img alt="Avatar" :src="path + item.image_one" cover></v-img>
          </v-avatar>
        </div>
        <div v-else class="text-center">
          <v-avatar size="80" class="my-1">
            <v-img
              alt="Avatar"
              :src="defaultImage"
              cover
            >
              <template v-slot:placeholder>
                <v-row align="center" class="fill-height ma-0" justify="center">
                  <v-progress-circular
                    color="grey-lighten-5"
                    indeterminate
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </div>
      </template>
      <template v-slot:[`item.image_two`]="{ item }">
        <div v-if="item.image_two" class="text-center">
          <v-avatar size="80" class="my-1">
            <v-img alt="Avatar" :src="path + item.image_two" cover></v-img>
          </v-avatar>
        </div>
        <div v-else class="text-center">
          <v-avatar size="80" class="my-1">
            <v-img
              alt="Avatar"
              :src="defaultImage"
              cover
            >
              <template v-slot:placeholder>
                <v-row align="center" class="fill-height ma-0" justify="center">
                  <v-progress-circular
                    color="grey-lighten-5"
                    indeterminate
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </div>
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <div v-html="item?.description"></div>
      </template>
      <template v-slot:[`item.description_one`]="{ item }">
        <div v-html="item?.description_one"></div>
      </template>
      <template v-slot:[`item.description_two`]="{ item }">
        <div v-html="item?.description_two"></div>
      </template>
      <template v-slot:[`item.description_three`]="{ item }">
        <div v-html="item?.description_three"></div>
      </template>
      <template v-slot:[`item.description_four`]="{ item }">
        <div v-html="item?.description_four"></div>
      </template>
      <template v-slot:[`item.description_five`]="{ item }">
        <div v-html="item?.description_five"></div>
      </template>
      <template v-slot:[`item.description_six`]="{ item }">
        <div v-html="item?.description_six"></div>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ new Date(item.createdAt).toLocaleString() }}
      </template>
      <template v-slot:[`item.staff.fullName`]="{ item }">
        {{ item.staff.fullName }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          class="ma-2"
          size="x-small"
          color="red-lighten-2"
          @click="editItem(item)"
        >
          <v-icon icon="mdi-pencil" start></v-icon>
          Edit
        </v-btn>
        <!--
            <v-icon title="Edit" class="me-2" size="small" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon title="Delete" size="small" @click="deleteItem(item)"> mdi-delete </v-icon> -->
      </template>
      <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination
            v-model="page"
            rounded="circle"
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </div>
      </template>
      <!-- End custom column table -->
    </v-data-table>
  </v-card>
</template>

<script>
import axios from "axios";
import {
  Path_LOGO_COMPANY,
  URL_PROJECT_TITLE,
  URL_UPLOAD_COMPANY_LOGO,
} from "@/utils/apiUrl";
import { getImageTokenHeaders, getTokenHeaders } from "@/utils/headerToken";
import { originalCode } from "@/utils/formatNumber";
import { QuillEditor } from "@vueup/vue-quill";
import { getFileExtension, getFileSizeInMB } from "@/utils/reusableFunctions";

export default {
  components: {
    QuillEditor,
  },
  data: () => ({
    path: Path_LOGO_COMPANY,
    snack: false,
    dialog: false,
    dialogDelete: false,
    visible: false,
    visibleMsg: true,
    isSubmitting: false,

    items: [],
    projectTitles: [],

    search: null,
    snackColor: null,
    snackText: null,
    msgError: null,

    title: null,
    description: null,
    image: null,
    previewImage: null,
    previewImage1: null,
    previewImage2: null,
    defaultImage:
      "https://cdn4.iconfinder.com/data/icons/modern-vector-flat-ui/512/camera_image_capture_modern_ui_flat_basic-512.png",
    hdimage: null,
    hdimage1: null,
    hdimage2: null,

    editedIndex: -1,
    hiddenId: 0,
    page: 1,
    itemsPerPage: 10,

    staffLoginId: originalCode(parseInt(localStorage.getItem("id"))),

    headers: [
      { title: "", key: "actions", sortable: false, align: "center" },
      { title: "", key: "image", align: "center" },
      { title: "", key: "image_one", align: "center" },
      { title: "", key: "image_two", align: "center" },
      { title: "Title", key: "title", align: "center" },
      { title: "Description", key: "description", align: "center" },
      { title: "Description One", key: "description_one", align: "center" },
      { title: "Description Two", key: "description_two", align: "center" },
      { title: "Description Three", key: "description_three", align: "center" },
      { title: "Description Four", key: "description_four", align: "center" },
      { title: "Description Five", key: "description_five", align: "center" },
      { title: "Description Six", key: "description_six", align: "center" },
      { title: "Create at", key: "createdAt", align: "center" },
      { title: "Created by", key: "staff.fullName", align: "center" },
    ],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Add New Project Title"
        : "Update Project Title";
    },
    buttonTitle() {
      return this.editedIndex === -1 ? "Save" : "Update";
    },
    pageCount() {
      return Math.ceil(this.projectTitles.length / this.itemsPerPage);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.populateprojectTitles();
  },
  methods: {
    clearContent() {
      this.hiddenId = 0;
      this.title = null;
      this.description = null;
      this.description_one = null;
      this.description_two = null;
      this.description_three = null;
      this.description_four = null;
      this.description_five = null;
      this.description_six = null;
      this.previewImage = null;
      this.previewImage1 = null;
      this.previewImage2 = null;
      this.hdimage = null;
      this.hdimage1 = null;
      this.hdimage2 = null;
      this.visibleMsg = true;
    },

    async populateprojectTitles() {
      await axios
        .get(URL_PROJECT_TITLE, { headers: getTokenHeaders() })
        .then((res) => {
          this.projectTitles = res.data;
          this.items.push(res.data);
          this.visible = res.data.length !== 0 ? true : false;
        });
    },

    editItem(item) {
      this.editedIndex = this.projectTitles.indexOf(item);
      this.hiddenId = item.id;
      this.editedItem = Object.assign({}, item);
      this.title = item.title;
      this.description = item.description;
      this.description_one = item.description_one;
      this.description_two = item.description_two;
      this.description_three = item.description_three;
      this.description_four = item.description_four;
      this.description_five = item.description_five;
      this.description_six = item.description_six;
      this.previewImage =
        item.image === null ? this.defaultImage : this.path + item.image;
      this.previewImage1 =
        item.image_one === null
          ? this.defaultImage
          : this.path + item.image_one;
      this.previewImage2 =
        item.image_two === null
          ? this.defaultImage
          : this.path + item.image_two;

      this.hdimage = item.image;
      this.hdimage1 = item.image1;
      this.hdimage2 = item.image2;

      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.projectTitles.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.hiddenId = item.id;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      //delete from arraylist
      this.projectTitles.splice(this.editedIndex, 1);
      //delete from DB
      const id = this.hiddenId;
      const url = URL_PROJECT_TITLE + id;
      axios
        .delete(url, { headers: getTokenHeaders() })
        .then(function () {
          this.snakeMessage("error", "Data has been deleted.");
        })
        .catch((error) => console.error("record deleted was an error!", error));

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.clearContent();
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async submitData() {
      const data = {
        title: this.title,
        image: this.hdimage,
        image_one: this.hdimage1,
        image_two: this.hdimage2,
        description: this.description,
        description_one: this.description_one,
        description_two: this.description_two,
        description_three: this.description_three,
        description_four: this.description_four,
        description_five: this.description_five,
        description_six: this.description_six,
      };

      if (this.editedIndex > -1) {
        // edit
        const id = this.hiddenId;
        const url = URL_PROJECT_TITLE + id;
        Object.assign(this.projectTitles[this.editedIndex], this.editedItem);

        await axios
          .patch(url, data, { headers: getTokenHeaders() })
          .then((response) => {
            this.snakeMessage("success", response.data.message);
            this.clearContent();
            this.dialog = false;
          })
          .catch(
            (error) => {
              this.visibleMsg = false;

              if (error.response.data.statusCode === 400) {
                this.snakeMessage("error", error.response.data.message);
                //this.msgError = error.response.data.message;
              } else if (error.request) {
                // The request was made but no response was received
                this.snakeMessage("error", error.request);
                //this.msgError = error.request;
                // Something happened in setting up the request that triggered an Error
                this.snakeMessage("error", error.message);
                //this.msgError = error.message;
              }

              this.dialog = true;
              return false;
            }
            //console.error("record updated was an error!", error)
          );
      } // create new
      else {
        data.createdBy = this.staffLoginId;
        await axios
          .post(URL_PROJECT_TITLE, data, { headers: getTokenHeaders() })
          .then((response) => {
            this.snakeMessage("success", response.data.message);
            this.clearContent();
            this.dialog = false;
          })
          .catch(
            (error) => {
              this.visibleMsg = false;

              if (error.response.data.statusCode === 400) {
                this.snakeMessage("error", error.response.data.message);
                //this.msgError = error.response.data.message;
              } else if (error.request) {
                // The request was made but no response was received
                this.snakeMessage("error", error.request);
                //this.msgError = error.request;
                // Something happened in setting up the request that triggered an Error
                this.snakeMessage("error", error.message);
                //this.msgError = error.message;
              }

              this.dialog = true;
              return false;
            }
            //console.error("record updated was an error!", error)
          );
      }

      //this.clearContent();
      this.populateprojectTitles();
    },

    async save() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        if (this.isSubmitting) return; // Prevent multiple submissions
        this.isSubmitting = true;

        try {
          // Send your form data to the server
          await this.submitData();
        } catch (error) {
          console.error(error);
        } finally {
          this.isSubmitting = false; // Re-enable the button after the request
        }
        //this.dialog = false;
        //this.close();
      }
    },

    snakeMessage(color, message) {
      this.snack = true;
      this.snackColor = color;
      this.snackText = message;
    },

    triggerFileInput(index) {
      this.$refs[`fileInput${index}`].click();
    },

    uploadImage(e, index) {
      const file = e.target.files[0];
      if (file) {
        var obj = this.invalidFileSizeOrFileExtension(file);
        if (obj.isTrue) {
          this.visibleMsg = false;
          this.msgError = obj.msg;
          return;
        }

        this.visibleMsg = true;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          if (index === 1) {
            this.previewImage = e.target.result;
          } else if (index === 2) {
            this.previewImage1 = reader.result;
          } else if (index === 3) {
            this.previewImage2 = reader.result;
          }

          console.log(this.previewImage);
        };

        let data = new FormData();
        data.append("file", e.target.files[0]);

        axios
          .post(URL_UPLOAD_COMPANY_LOGO, data, {
            headers: getImageTokenHeaders(),
          })
          .then((response) => {
            if (index === 1) {
              this.hdimage = response.data.filename;
            } else if (index === 2) {
              this.hdimage1 = response.data.filename;
            } else if (index === 3) {
              this.hdimage2 = response.data.filename;
            }

            console.log("Image has been uploaded.");
          });
      }
    },

    invalidFileSizeOrFileExtension(file) {
      let isTrue = false;
      let msg = null;
      const fileSize = getFileSizeInMB(file);
      const fileExtension = getFileExtension(file);

      if (fileSize >= 6) {
        // 6MB
        isTrue = true;
        msg = "File size is biggest 6MB.";
      }

      if (fileExtension === null) {
        isTrue = true;
        msg = "File extension must be jpg, jpeg, png, bmp";
      }

      return { isTrue, msg };
    },
  },
};
</script>
<style scoped>
.elevated-card {
  border-radius: 12px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  padding: 16px;
}

.toolbar {
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.image-card {
  border-radius: 10px;
  overflow: hidden;
  transition: 0.3s ease-in-out;
  height: 200px; /* Adjusted */
}

.image-upload {
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.image-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  text-align: center;
  padding: 5px;
  font-size: 12px;
  font-weight: bold;
}
/* Image Upload Cards */
.image-card {
  width: 100%;
  height: auto;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}
.image-card:hover {
  transform: scale(1.05);
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
}

/* Image Overlay */
.image-overlay {
  position: absolute;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  width: 100%;
  text-align: center;
  padding: 6px;
  font-size: 12px;
  transition: background 0.3s ease-in-out;
}
.image-card:hover .image-overlay {
  background: rgba(0, 0, 0, 0.8);
}

/* Description Labels */
.desc-label {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 5px;
}

/* Quill Editor */
.desc-editor {
  border-radius: 8px;
  border: 1px solid #ddd;
  transition: all 0.3s ease-in-out;
}
.desc-editor:hover {
  border-color: #2196f3;
}

/* Form Fields */
.custom-text-field {
  font-size: 16px;
}

/* Mobile Optimizations */
@media (max-width: 768px) {
  /* Stack Images in a Column */
  .v-row .v-col {
    display: flex;
    justify-content: center;
  }

  .image-card {
    max-width: 180px;
    margin-bottom: 10px;
  }

  /* Reduce Spacing for Quill Editors */
  .desc-editor {
    height: 120px !important;
  }
}
</style>
